/** Matches list user organizations node shape (GraphQL may return numeric ids). */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();export type UserOrganizationLike = {
  isPersonal?: boolean | null
  orgId?: string | number | null
  orgName?: string | null
  role?: string | null
}

/**
 * Resolves the active organization: session orgId → URL /organization/:id → personal org fallback.
 * Matches OrganizationSwitcher behavior.
 */
export function getCurrentUserOrganization(
  userOrganizations: (UserOrganizationLike | null | undefined)[],
  orgId: string | number | null | undefined,
  pathname: string | null | undefined,
): UserOrganizationLike | undefined {
  const orgs = userOrganizations.filter((o): o is UserOrganizationLike => o != null)

  if (orgId != null && orgId !== "") {
    const org = orgs.find((o) => o.orgId === orgId)
    if (org) return org
  }

  const orgMatch = pathname?.match(/^\/organization\/([^/]+)/)
  if (orgMatch) {
    const orgIdFromUrl = orgMatch[1]
    const org = orgs.find((o) => o.orgId === orgIdFromUrl)
    if (org) return org
  }

  return orgs.find((o) => o.isPersonal)
}
